import { validationMixin } from 'vuelidate'

export const importCsvValidation = {
  mixins: [validationMixin],

  computed: {
    errors () {
      const errors = {}

      return errors
    }
  },

  validations: {
    contextName: {}
  }
}
